// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XU32","col":"styles_col__3jZBC"};